var tarifs = {
  1: {
    1: 119,
    2: 119,
    3: 119,
    4: 97,
    5: 97,
    6: 76,
    7: 76,
    8: 76,
    9: 76,
    10: 97,
    11: 97,
    12: 119,
  },
  2: {
    1: 321,
    2: 301,
    3: 282,
    4: 243,
    5: 224,
    6: 204,
    7: 204,
    8: 224,
    9: 243,
    10: 282,
    11: 301,
    12: 321,
  },
  3: {
    1: 501,
    2: 467,
    3: 432,
    4: 397,
    5: 397,
    6: 397,
    7: 432,
    8: 467,
    9: 501,
    10: 536,
    11: 536,
    12: 536,
  },
  4: {
    1: 782,
    2: 782,
    3: 782,
    4: 782,
    5: 782,
    6: 782,
    7: 782,
    8: 782,
    9: 782,
    10: 782,
    11: 782,
    12: 782,
  },
};

document.addEventListener('turbo:load', function() {
  var select = document.querySelector('.v-tarifs-select');
  if (!select) return;

  var prices = document.querySelectorAll('.v-tarifs-price');
  var price1 = document.querySelector('.v-tarifs-price-1');
  var price2 = document.querySelector('.v-tarifs-price-2');
  var price3 = document.querySelector('.v-tarifs-price-3');
  var price4 = document.querySelector('.v-tarifs-price-4');

  const updatePrice = (elem, abo, month) => {
    elem.innerHTML = tarifs[abo][month];
  }

  const updatePrices = () => {
    let activeMonth = select.querySelector('option:checked').innerHTML.toLowerCase();
    updatePrice(price1, 1, select.value);
    updatePrice(price2, 2, select.value);
    updatePrice(price3, 3, select.value);
    updatePrice(price4, 4, select.value);
    prices.forEach((price) => {
      price.classList.add('do-animate');
      setTimeout(() => { price.classList.remove('do-animate') }, 500)
    });
    document.querySelectorAll('.v-tarifs-price__month').forEach(function(elem) {
      elem.innerHTML = activeMonth;
    });
  }

  updatePrices();
  select.addEventListener('change', elem => updatePrices());
});
